import { axios } from '@/utils/request'

// 产品库列表
export function getOpenMaterial(params) {
  return axios({
    url: '/distribution/product',
    method: 'GET',
    params
  })
}
// 查看产品库产品详情
export function viewProduct(id) {
  return axios({
    url: '/distribution/product/' + id,
    method: 'GET'
  })
}
// 模板批量导出
export function productGruopExport(data) {
  return axios({
    url: '/distribution/productExportRecord',
    method: 'POST',
    data
  })
}

// 批量删除
export function productDelete(data) {
  return axios({
    url: '/distribution/product/deletes',
    method: 'POST',
    data
  })
}
// 批量更改来图定制
export function changeBuyerDesigns(data) {
  return axios({
    url: '/distribution/product/changeBuyerDesigns',
    method: 'POST',
    data
  })
}
// 批量取消来图定制
export function cancelBuyerDesigns(data) {
  return axios({
    url: '/distribution/product/cancelBuyerDesigns',
    method: 'POST',
    data
  })
}
// 商品
export function userBasicProduct() {
  return axios({
    url: '/distribution/userBasicProduct',
    method: 'GET'
  })
}
// stockSku
export function getStockSku() {
  return axios({
    url: '/distribution/stockSku',
    method: 'GET'
  })
}

// 获取变体价格设置
export function getProductTemplateAmount(data) {
  return axios({
    url: '/distribution/productTemplateAmount/getProductTemplateAmount',
    method: 'POST',
    data
  })
}

// 添加变体价格
export function addProductTemplateAmount(data) {
  return axios({
    url: '/distribution/productTemplateAmount',
    method: 'POST',
    data
  })
}

// 保存产品导出定价重置
export function saveAmountTemplate(data) {
  return axios({
    url: '/distribution/productTemplateAmount/saveAmountTemplate',
    method: 'POST',
    data
  })
}

// 更改变体价格
export function editProductTemplateAmount(data) {
  return axios({
    url: '/distribution/productTemplateAmount/' + data.id,
    method: 'PUT',
    data: data.data
  })
}

// 删除变体价格
export function deleteProductTemplateAmount(id) {
  return axios({
    url: '/distribution/productTemplateAmount/' + id,
    method: 'DELETE'
  })
}

// 修改名称
export function modifyNameFn(data, id) {
  return axios({
    url: '/distribution/product/' + id,
    method: 'PUT',
    data
  })
}
// 批量修改名字
export function modifyNames(data) {
  return axios({
    url: '/distribution/product/names',
    method: 'POST',
    data
  })
}
// 批量加入购物车
export function joinCar(data) {
  return axios({
    url: '/distribution/cartItem/adds',
    method: 'POST',
    data
  })
}
// 获取独有域名
export function getDomainList() {
  return axios({
    url: '/distribution/productTemplate/getDomain',
    method: 'GET'
  })
}

// 获取默认独有域名
export function getDomain() {
  return axios({
    url: '/distribution/userConfig/productTemplate',
    method: 'GET'
  })
}
// 修改独有域名
export function putDomain(data) {
  return axios({
    url: '/distribution/userConfig/productTemplate',
    method: 'PUT',
    data
  })
}
// 获取运费成本
export function getLogisticAmount(data) {
  return axios({
    url: '/distribution/getLogisticAmount',
    method: 'POST',
    data
  })
}
// 获取利润率
export function getProfit(data) {
  return axios({
    url: '/distribution/getProfit',
    method: 'POST',
    data
  })
}
// 获取产品单价
export function getSKUPrice(params) {
  return axios({
    url: '/distribution/getshowPrice',
    method: 'GET',
    params
  })
}
// 产品组合
export function makeCombine(data) {
  return axios({
    url: '/distribution/product/makeCombine',
    method: 'POST',
    data
  })
}
// 产品拆分
export function makePart(data) {
  return axios({
    url: '/distribution/product/makePart',
    method: 'POST',
    data
  })
}
// 指定父体
export function changeParent(data) {
  return axios({
    url: '/distribution/product/changeParent',
    method: 'POST',
    data
  })
}
// 移除单变体
export function deleteCombine(data) {
  return axios({
    url: '/distribution/product/deleteCombine',
    method: 'POST',
    data
  })
}
// 导出产品效果图
export function exportProductShowImage(data) {
  return axios({
    url: '/distribution/product/exportProductShowImage',
    method: 'POST',
    data
  })
}

// 获取重新设计参数
export function getProductDesignInfo(params) {
  return axios({
    url: '/distribution/product/getDesignInfo',
    method: 'GET',
    params
  })
}

// 重新设计
export function setProductDesignInfo({ id, data }) {
  return axios({
    url: '/distribution/product/setDesignInfo?id=' + id,
    method: 'POST',
    data
  })
}
// 批量修改标签
export function setProductTags(data) {
  return axios({
    url: '/distribution/product/tags',
    method: 'POST',
    data
  })
}
// 用户产品分类
export function getUserProductCategory(params) {
  return axios({
    url: '/distribution/userProductCategory',
    method: 'GET',
    params
  })
}
// 添加用户产品分类
export function setUserProductCategory(data) {
  return axios({
    url: '/distribution/userProductCategory',
    method: 'POST',
    data
  })
}
// 修改用户产品分类
export function putUserProductCategory(data, id) {
  return axios({
    url: '/distribution/userProductCategory/' + id,
    method: 'PUT',
    data
  })
}
// 删除用户产品分类
export function deleteUserProductCategory(id) {
  return axios({
    url: '/distribution/userProductCategory/' + id,
    method: 'DELETE'
  })
}
// 批量更改分类
export function productCategorys(data) {
  return axios({
    url: '/distribution/product/categorys',
    method: 'POST',
    data
  })
}
// 设置产品主图颜色
export function setMasterImgColor(data) {
  return axios({
    url: '/distribution/product/setMasterImgColor',
    method: 'POST',
    data
  })
}
// 解冻图片
export function unFreezeShowimages(data) {
  return axios({
    url: '/distribution/product/unfreezeShowImages',
    method: 'POST',
    data
  })
}
